import script from "./SchedulePackageStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchedulePackageStep.vue?vue&type=script&setup=true&lang=ts"

import "./SchedulePackageStep.vue?vue&type=style&index=0&id=c2be5244&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2be5244"]])

export default __exports__